const timeExpirationInMillis = 7200000;

export { timeExpirationInMillis }


// WEBPACK FOOTER //
// ./src/constants/session-configuration.js